import { Link, Typography } from '@mui/material';
import config from 'config/config';
import { TournamentSettingsTitle } from 'modules/tournaments/components/TournamentSettingsTitle';
import React, { FC } from 'react';
import { useStyles } from './TournamentSupport.styles';

export const TournamentSupport: FC = () => {
  const { classes } = useStyles();

  return (
    <>
      <TournamentSettingsTitle>Tournament Support</TournamentSettingsTitle>
      <Typography mt={1}>
        For support or to report a player, please visit the{' '}
        <Link
          className={classes.link}
          href={config.discordInviteUrl}
          underline="always"
          target="_blank"
        >
          OkLetsPlay Discord
        </Link>
        .
      </Typography>
    </>
  );
};
